import styled, { css } from 'styled-components'
import { desktopBreakpoint, tabletBreakpoint, wideScreenBreakpoint } from 'react-components'
import { NewTagContainer as FilterNewTagContainer } from '../../app-components/filter-sort-section/styles'

export const Section = styled.section<{ compact?: boolean }>`
    width: 100%;
    ${({ compact }) =>
        !compact &&
        css`
            margin-top: 1.5rem;
        `}
`

export const Container = styled.div<{ compact?: boolean }>`
    overflow: hidden;
    max-width: 83rem;
    margin: auto;
    ${({ compact }) =>
        compact
            ? css`
                  padding: 0 1rem 0 0;
                  @media only screen and (min-width: ${tabletBreakpoint.min}px) {
                      padding: 0 1.5rem 0 0;
                  }
                  @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
                      padding: 0 4rem 0 0;
                  }
              `
            : css`
                  padding: 2rem 1rem 3rem 0;
                  @media only screen and (min-width: ${tabletBreakpoint.min}px) {
                      padding: 2.5rem 1.5rem 3rem 0;
                  }
                  @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
                      padding: 3rem 4rem 4rem 0;
                  }
              `}
`

export const TitleContainer = styled.div`
    padding: 0.25rem 0 0.25rem;
`

export const NewTagContainer = styled(FilterNewTagContainer)`
    margin-left: 0;
`

export const Title = styled.h2(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: 1.25rem;
        font-weight: 600;
        line-height: 1.75rem;
        color: #282828;
        margin: 0;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            font-size: 1.563rem;
            line-height: 1.875rem;
        }
    `,
)

export const Subtitle = styled.p(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: ${theme.typography.font.size.small};
        font-weight: 400;
        line-height: 1.375rem;
        color: #5f5f5f;
        margin: 0.5rem 0 0.375rem;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            font-size: ${theme.typography.font.size.medium};
            line-height: 1.5rem;
        }
    `,
)

// Reserves layout space before GYG's iframe paints to prevent CLS.
// Set outside WidgetScaler so it is not affected by zoom — the minHeight here
// equals the expected visual height of the zoomed widget (~20rem).
// Measure actual GYG render height and tune if needed.
export const WidgetWrapper = styled.div`
    min-height: 20rem;
`

// GYG renders into a cross-origin iframe so card internals can't be styled directly.
// zoom scales the iframe proportionally and collapses the layout space it frees up,
// unlike transform:scale which leaves a gap. Adjust this value to taste.
// Note: requires Firefox 126+ — on older Firefox the widget renders unscaled (acceptable degradation).
export const WidgetScaler = styled.div`
    zoom: 0.82;
`

export const ShowAllContainer = styled.div`
    margin-top: 1.5rem;
`

export const VisuallyHidden = styled.span`
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
`

export const ShowAllLink = styled.a(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.5rem 1.25rem;
        border: 1px solid #282828;
        border-radius: 0.75rem;
        font-family: ${theme.typography.font.family.lato};
        font-weight: 600;
        font-size: 0.875rem;
        line-height: 1.5rem;
        color: #282828;
        text-decoration: none;
        width: 100%;
        box-sizing: border-box;
        transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out, border-color 0.2s ease-in-out;

        &:hover {
            background-color: #84bcf5;
            color: #282828;
            border-color: #84bcf5;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            width: fit-content;
            min-width: 11.375rem;
        }
    `,
)
